// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZgKY06LqCkMT_EH3IH12{align-items:center;gap:8px;display:flex}.ynHtWeIemYswy9ELoTMi{border-radius:50%;flex-shrink:0;width:8px;height:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cell": `ZgKY06LqCkMT_EH3IH12`,
	"tagColor": `ynHtWeIemYswy9ELoTMi`
};
export default ___CSS_LOADER_EXPORT___;
